const AboutSection = () => {
  return (
    <section className="flex flex-col items-center px-4 py-16">
      <img 
        id="about-us__img" 
        src="https://static2.givesendgo.com/vue/home/about-bg.jpg" 
        className="relative rounded-lg w-full max-w-7xl h-64 md:h-[550px] object-cover shadow-lg" 
        alt="About DonatePe"
      />
      
      <div className="relative flex flex-col w-full max-w-4xl px-8 py-8 mt-0 space-y-4 leading-relaxed text-left lg:px-16 rounded-lg shadow-lg bg-white sm:-mt-12 md:-mt-16">
        <h2 className="text-2xl md:text-5xl lg:text-4xl font-bold text-gray-900 mb-6">
          About DonatePe
        </h2>
        
        <p className="text-gray-600 text-base md:text-lg leading-relaxed">
          In 2014, three siblings had an idea. What would it look like if we took the newly popular idea of crowdfunding and stretched it beyond just funding help for people's material needs but also providing hope for people's spiritual needs? Out of those discussions, DonatePe was born. After over a year of development and setbacks, DonatePe was launched with a beta version in early 2015.
        </p>
        
        <div className="flex mt-8">
          <a 
            href="/about" 
            className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-white bg-[#2d6a4f] rounded-full hover:bg-[#245c43] transition-colors"
          >
            Learn More
          </a>
        </div>
      </div>
    </section>
  )
}

export default AboutSection